
import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator'

@Component({})
export default class Pagination extends Vue {
  @Prop({ default: 5, required: false }) maxVisibleButtons: number
  @Prop({ default: null, required: true }) totalPages!: number
  @Prop({ default: null, required: true }) total!: number
  @Prop({ default: null, required: true }) perPage!: number
  @Prop({ default: null, required: true }) currentPage!: number
  selectedItemPerpage: number = 8

  get startPage() {
    if (this.currentPage <= 2) {
      return 1
    }
    if (this.currentPage >= this.totalPages - 1) {
      return this.totalPages - 4
    }

    return this.currentPage - 2
  }
  get endPage() {
    return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages)
  }
  get pages() {
    const range = []
    for (let i: number = this.startPage; i <= this.endPage; i += 1) {
      range.push({
        name: i,
        isDisabled: i === this.currentPage,
      })
    }
    return range
  }
  get isInFirstPage() {
    return this.currentPage === 1
  }
  get isInLastPage() {
    return this.currentPage === this.totalPages
  }
  @Emit('page-changed')
  onClickFirstPage() {
    document.body.getElementsByTagName('s-page')[0].scrollTop = 0
    return 1
  }
  @Emit('page-changed')
  onClickPreviousPage() {
    document.body.getElementsByTagName('s-page')[0].scrollTop = 0
    return this.currentPage - 1
  }
  @Emit('page-changed')
  onClickPage(page) {
    document.body.getElementsByTagName('s-page')[0].scrollTop = 0
    return page
  }
  @Emit('page-changed')
  onClickNextPage() {
    document.body.getElementsByTagName('s-page')[0].scrollTop = 0
    return this.currentPage + 1
  }
  @Emit('page-changed')
  onClickLastPage() {
    document.body.getElementsByTagName('s-page')[0].scrollTop = 0
    return this.totalPages
  }
  isPageActive(page) {
    document.body.getElementsByTagName('s-page')[0].scrollTop = 0
    return this.currentPage === page
  }
  @Emit('item-per-page')
  @Watch('selectedItemPerpage', { immediate: true, deep: true })
  onSelectedItem() {
    return this.selectedItemPerpage
  }
}
